import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { transactionInternalApi } from '../apis';
import { TransactionSearchQuery } from './TransactionSearch';
import { saveEntitySearchEvent } from '../tracking/userEventTracker';

const DEFAULT_PAGE_SIZE = 20;

export const useQueryTransactions = (transactionSearchQuery: TransactionSearchQuery) => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: ['transactions', JSON.stringify(transactionSearchQuery)],
    queryFn: async () => {
      const sanitizedQuery = {
        ...transactionSearchQuery,
        filters: transactionSearchQuery.filters.map((filter) => ({
          ...filter,
          query: undefined,
        })),
      };
      saveEntitySearchEvent(sanitizedQuery);
      return transactionInternalApi.findAllTransactionsInternal({
        internalApiTransactionSearchQuery: {
          ...transactionSearchQuery,
          size: DEFAULT_PAGE_SIZE,
        },
      });
    },
  });
};
